import { DataSource } from "@me8eon/data_sources";

export const elasticSearchKnn = "elasticSearchKnn";

export function elasticSearchKnnDs<Filters>(): DataSource<Filters> {
    return {
        plugin: "datasource",
        type: elasticSearchKnn,
        query: ({ filters, names }): any => {
            const query = {
                index: "some hack for knn",
                body: {
                    query: {
                        filters,
                        match: {
                            name: names,
                        },
                    },
                },
            };
            return { query, filters };
        },
        search: async (query) => {
            return { data: "search results would go here" };
        },
        results: (res: any) => res,
    };
};
